import EnabledStatusBadge from './EnabledStatusBadge';

export default EnabledStatusBadge;
